import {useAccordionButton} from "react-bootstrap";

const AccordionToggle = ({eventKey, toggleRef}) => {
    const decoratedOnClick = useAccordionButton(eventKey);

    return <button className="d-none" ref={toggleRef} onClick={decoratedOnClick}/>;
}

export default AccordionToggle;